/* tslint:disable */
/* eslint-disable */
/**
 * Muscula App API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiErrorResponse,
  CreateResponseGenericApiResponse,
  LogDocument,
  LogDocumentGenericApiResponse,
  LogDocumentListGenericApiResponse,
  SuccessfullApiResponse,
} from '../models';
import {
    ApiErrorResponseFromJSON,
    ApiErrorResponseToJSON,
    CreateResponseGenericApiResponseFromJSON,
    CreateResponseGenericApiResponseToJSON,
    LogDocumentFromJSON,
    LogDocumentToJSON,
    LogDocumentGenericApiResponseFromJSON,
    LogDocumentGenericApiResponseToJSON,
    LogDocumentListGenericApiResponseFromJSON,
    LogDocumentListGenericApiResponseToJSON,
    SuccessfullApiResponseFromJSON,
    SuccessfullApiResponseToJSON,
} from '../models';

export interface ApiLogsListProjectIdGetRequest {
    projectId: string;
}

export interface ApiLogsLogIdDeleteRequest {
    logId: string;
}

export interface ApiLogsLogIdGetRequest {
    logId: string;
}

export interface ApiLogsLogIdPutRequest {
    logId: string;
    logDocument?: LogDocument;
}

export interface ApiLogsNewPostRequest {
    logDocument?: LogDocument;
}

/**
 * 
 */
export class LogsApi extends runtime.BaseAPI {

    /**
     */
    async apiLogsListProjectIdGetRaw(requestParameters: ApiLogsListProjectIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogDocumentListGenericApiResponse>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling apiLogsListProjectIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Logs/list/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogDocumentListGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiLogsListProjectIdGet(requestParameters: ApiLogsListProjectIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogDocumentListGenericApiResponse> {
        const response = await this.apiLogsListProjectIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiLogsLogIdDeleteRaw(requestParameters: ApiLogsLogIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiLogsLogIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Logs/{logId}`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiLogsLogIdDelete(requestParameters: ApiLogsLogIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiLogsLogIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiLogsLogIdGetRaw(requestParameters: ApiLogsLogIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogDocumentGenericApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiLogsLogIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Logs/{logId}`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogDocumentGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiLogsLogIdGet(requestParameters: ApiLogsLogIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogDocumentGenericApiResponse> {
        const response = await this.apiLogsLogIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiLogsLogIdPutRaw(requestParameters: ApiLogsLogIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessfullApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiLogsLogIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Logs/{logId}`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters.logId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LogDocumentToJSON(requestParameters.logDocument),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiLogsLogIdPut(requestParameters: ApiLogsLogIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessfullApiResponse> {
        const response = await this.apiLogsLogIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiLogsNewPostRaw(requestParameters: ApiLogsNewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateResponseGenericApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/Logs/New`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LogDocumentToJSON(requestParameters.logDocument),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateResponseGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiLogsNewPost(requestParameters: ApiLogsNewPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateResponseGenericApiResponse> {
        const response = await this.apiLogsNewPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
